import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { WxLaunchHack } from '@ifeng-fe/three_terminal/es/mobile/wxLaunchHack/dynamic';
import { setAppQuery, isMobile } from '@src/utils';
import { isGrounds } from '@src/utils/app';

const Layout = ({ content }) => {
    const wxLaunchHackData = {
        callAppConfig: {
            docType: 'web',
            pid: setAppQuery(window.location.href),
            kind: 'inter_yxjl01',
            noKindFrom: 1,
            download: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK7268827238527806464',
            downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=9173',
        }
    };

    return (
        <div>{!isGrounds && isMobile() ? <div className={styles.callApp}><WxLaunchHack content={wxLaunchHackData} /></div> : null}</div>
    );
};

Layout.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Layout);
